/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { AddWhite, EditIcon, SearchIcon, ToggleOffIcon, ToggleOnIcon, TrashIcon, ViewIcon } from '../../../assets/icons';
import { Photo } from '../../../assets/img';
import { classNames, Constants, getUpdatedState, Globals } from '../../../utils';
import { FallbackImage, Input, Pagination, Select } from '../../../components';
import { VehicleService } from '../../../services';

const status = [
  { value: '0', label: 'Inactivo' },
  { value: '1', label: 'Activo' },
];

const conditions = [
  { value: '0', label: 'Disponible' },
  { value: '1', label: 'Asignado' },
];

const Vehicles = () => {
  const navigate = useNavigate();
  const confirmModalRef = useRef();
  const { data, deleteItem, filters, goToPage, onChange, pagination, reload, search, selects, updateStatus } = useFetchTable();
  const [selectedVehicle, setSelectedVehicle] = useState(null);

  const openDetail = (vehicle) => {
    setSelectedVehicle(vehicle);
    confirmModalRef.current?.showModal();
  };

  const closeDetail = () => {
    setSelectedVehicle(null);
    confirmModalRef.current?.close();
  };

  return (
    <main className="p-4 w-full">
      <dialog
        ref={confirmModalRef}
        className="fixed inset-0 z-50 overflow-y-auto bg-transparent"
        onClick={e => { if (e.target === confirmModalRef.current) closeDetail(); }}
      >
        {selectedVehicle && (
          <div className="w-[36rem] bg-white rounded-2xl shadow-xl overflow-hidden max-h-[90vh] overflow-y-auto mx-4">
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray6">
              <h2 className="text-lg font-bold text-text">Detalles del vehículo</h2>
              <button
                type="button"
                className="p-1.5 rounded-full hover:bg-gray5 transition-colors"
                onClick={closeDetail}
              >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-text">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="p-6 space-y-6">
              <div className="flex gap-5">
                <FallbackImage
                  src={selectedVehicle?.photo}
                  placeholder={Photo}
                  className="w-24 h-24 rounded-xl object-cover"
                  placeholderClassName="w-24 h-24 rounded-xl object-cover"
                  alt="Vehículo"
                />
                <div className="flex flex-col justify-center gap-2">
                  <p className="text-2xl font-bold text-text">{selectedVehicle?.plaque}</p>
                  <span className={classNames('px-3 py-1 rounded-full text-xs font-bold w-fit', selectedVehicle?.driver_id ? 'bg-orange/25 text-orange' : 'bg-green/25 text-green')}>
                    {selectedVehicle.driver_id ? 'Asignado' : 'Disponible'}
                  </span>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-x-8 gap-y-4">
                <div>
                  <p className="text-xs text-default font-medium uppercase tracking-wider">Marca</p>
                  <p className="text-sm font-semibold text-text mt-0.5">{selectedVehicle.brand}</p>
                </div>
                <div>
                  <p className="text-xs text-default font-medium uppercase tracking-wider">Modelo</p>
                  <p className="text-sm font-semibold text-text mt-0.5">{selectedVehicle.model}</p>
                </div>
                <div>
                  <p className="text-xs text-default font-medium uppercase tracking-wider">Año</p>
                  <p className="text-sm font-semibold text-text mt-0.5">{selectedVehicle.year}</p>
                </div>
                <div>
                  <p className="text-xs text-default font-medium uppercase tracking-wider">Color</p>
                  <p className="text-sm font-semibold text-text mt-0.5">{selectedVehicle.color}</p>
                </div>
                <div>
                  <p className="text-xs text-default font-medium uppercase tracking-wider">Tipo de vehículo</p>
                  <p className="text-sm font-semibold text-text mt-0.5">{selectedVehicle.vehicle_types?.at(0)?.name}</p>
                </div>
                <div>
                  <p className="text-xs text-default font-medium uppercase tracking-wider">Aire acondicionado</p>
                  <p className="text-sm font-semibold text-text mt-0.5">{selectedVehicle?.conditions?.air_conditioning ? 'Sí' : 'No'}</p>
                </div>
              </div>

              <hr className="border-gray6" />

              <div className="grid grid-cols-2 gap-x-8 gap-y-4">
                <div>
                  <p className="text-xs text-default font-medium uppercase tracking-wider">Propietario</p>
                  <p className="text-sm font-semibold text-text mt-0.5">
                    { selectedVehicle.belongs_to === Constants.BELONGS_TO.OWNER ? (selectedVehicle?.owner?.person?.fullName || 'Sin asignar') : 'Maxer' }
                  </p>
                </div>
                <div>
                  <p className="text-xs text-default font-medium uppercase tracking-wider">Conductor asignado</p>
                  <p className="text-sm font-semibold text-text mt-0.5">
                    { selectedVehicle.driver?.person?.fullName || 'Sin asignar' }</p>
                </div>
              </div>
            </div>

            <div className="flex justify-end px-6 py-4 border-t border-gray6">
              <button
                type="button"
                className="px-6 py-2 bg-black text-white font-semibold rounded-full hover:bg-gray-800 transition-colors text-sm"
                onClick={closeDetail}
              >
                Cerrar
              </button>
            </div>
          </div>
        )}
      </dialog>

      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-4">
        <div className="grid grid-cols-[2fr_1fr_1fr_1fr_1fr] items-center gap-3">
          <Input
            placeholder="Buscar por placa, marca o modelo"
            value={filters.search}
            onValueChange={v => onChange('search', v)}
            prepend={
              <img src={SearchIcon} className="w-4 h-4" alt="" />
            }
          />

          <Select
            placeholder="Tipo de vehículo"
            items={selects.types}
            value={filters.type}
            onValueChange={v => onChange('type', v)}
          />

          <Select
            placeholder="Estado"
            items={conditions}
            value={filters.condition}
            onValueChange={v => onChange('condition', v)}
          />

          <Select
            placeholder="Estatus"
            items={status}
            value={filters.status}
            onValueChange={v => onChange('status', v)}
          />

          <div className="flex gap-4">
            <button
              className="bg-red hover:bg-red-700 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors"
              onClick={search}
            >
              Filtrar
            </button>
            <button
              className="bg-black hover:bg-gray-800 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors"
              onClick={() => reload()}
            >
              Limpiar
            </button>
          </div>
        </div>
      </div>

      <div className="flex justify-between pb-4">
        <div />

        <Link to="/vehicles/create" className="flex items-center gap-2 bg-[#22c55e] hover:bg-green text-white px-2 py-2 rounded-lg text-sm font-medium transition-colors">
          <img src={AddWhite} className="w-4 h-4" alt="" />
          Nuevo vehículo
        </Link>
      </div>

      <div className="bg-white rounded-2xl shadow-md overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="text-default text-xs tracking-wider border-b border-gray5 [&>th]:py-4">
                <th className="px-6">Foto</th>
                <th>Placa</th>
                <th>Marca</th>
                <th>Modelo</th>
                <th>Tipo de vehículo</th>
                <th>Año</th>
                <th>Color</th>
                <th>Propietario</th>
                <th>Conductor asignado</th>
                <th>Estado</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody className="text-sm text-text [&>td]:py-3">
              {data.map((item) => (
                <tr key={item.id} className="hover:bg-gray5 transition-colors odd:bg-gray5">
                  <td className="px-6 py-3">
                    <FallbackImage
                      src={item.photo}
                      placeholder={Photo}
                      className="w-12 h-12 object-cover"
                      placeholderClassName="w-12 h-12 object-cover"
                      alt="Vehículo"
                    />
                  </td>
                  <td className="font-medium">{item.plaque}</td>
                  <td>{item.brand}</td>
                  <td>{item.model}</td>
                  <td className="max-w-48">{item.vehicle_types?.map(x => x.name).join(', ')}</td>
                  <td>{item.year}</td>
                  <td>{item.color}</td>
                  <td>{ item.belongs_to === Constants.BELONGS_TO.OWNER ? (item?.owner?.person?.fullName || 'Sin asignar') : 'Maxer' }</td>
                  <td>{item.driver?.person?.fullName || 'Sin asignar'}</td>
                  <td>
                    <span className={classNames('px-3 py-1 rounded-full text-xs font-bold', item.driver_id ? 'bg-orange/25 text-orange' : 'bg-green/25 text-green')}>
                      {item.driver_id ? 'Asignado' : 'Disponible'}
                    </span>
                  </td>
                  <td>
                    <div className="flex items-center gap-3">
                      {item.status === Constants.VEHICLE_STATUS.ACTIVE ? (
                        <img
                          key={`${item.id}-on`}
                          src={ToggleOnIcon}
                          className="w-10 h-10 object-contain cursor-pointer"
                          onClick={() => updateStatus(item.id, Constants.VEHICLE_STATUS.INACTIVE)}
                          alt=""
                        />
                      ) : (
                        <img
                          key={`${item.id}-off`}
                          src={ToggleOffIcon}
                          className="w-10 h-10 object-contain cursor-pointer"
                          onClick={() => updateStatus(item.id, Constants.VEHICLE_STATUS.ACTIVE)}
                          alt=""
                        />
                      )}
                      <img
                        src={ViewIcon}
                        className="w-5 h-5 object-contain cursor-pointer"
                        onClick={() => openDetail(item)}
                        alt=""
                      />
                      <img
                        src={EditIcon}
                        className="w-5 h-5 object-contain cursor-pointer"
                        onClick={() => navigate(`/vehicles/${btoa(item.id)}/edit`)}
                        alt=""
                      />
                      <img
                        src={TrashIcon}
                        className="w-5 h-5 object-contain cursor-pointer"
                        onClick={() => deleteItem(item.id)}
                        alt=""
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {!data.length && (
            <p className="py-8 text-text text-center">Sin datos para mostrar</p>
          )}
        </div>

        <div className="px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-text">
            Mostrando { ((pagination.page - 1) * pagination.perPage) + 1 } a { Math.min(pagination.page * pagination.perPage, pagination.total) } de { pagination.total } vehículos
          </p>
          <Pagination
            active={pagination.page}
            pages={pagination.pages}
            onChange={goToPage}
          />
        </div>
      </div>
    </main>
  );
};

const useFetchTable = () => {
  const initialFilters = {
    page: 1,
    perPage: Constants.PER_PAGE,
    search: '',
    type: '',
    status: '',
    condition: '',
  };

  const initialPagination = {
    page: 1,
    pages: 1,
    total: 0,
    perPage: Constants.PER_PAGE,
  };

  const [data, setData] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const [pagination, setPagination] = useState(initialPagination);
  const [selects, setSelects] = useState({
    types: [],
  });

  const fetchData = async () => {
    if (!canFetch) return;
    setCanFetch(false);

    try {
      const payload = await getUpdatedState(setFilters);
      const response = await VehicleService.admin.findAll(payload);
      const { data, ...rest } = response;

      setData(data);
      setPagination(rest);
      setCanFetch(true);

    } catch (error) {
      setData([]);
      onError(String(error));
    }
  }

  const getSelects = async () => {
    try {
      const response = await VehicleService.admin.getSelects();
      setSelects({
        types: response.types?.map(x => ({ value: x.id, label: x.name })) || [],
      });

    } catch (error) {
      selects([]);
      onError(String(error));
    }
  }

  const deleteItem = async (id) => {
    Globals.confirm('¿Está seguro de que desea eliminar este vehículo?', async () => {
      if (!canFetch) return;
      setCanFetch(false);

      try {
        await VehicleService.admin.destroy(id);
        toast.success('Vehículo eliminado con éxito');
        fetchData();

      } catch (error) {
        onError(String(error));
      }
      setCanFetch(true);
    });
  }

  const updateStatus = async (id, status) => {
    const statusText = status === Constants.VEHICLE_STATUS.ACTIVE ? 'activar' : 'desactivar';
    Globals.confirm(`¿Está seguro de que desea ${statusText} este vehículo?`, async () => {
      if (!canFetch) return;
      setCanFetch(false);

      try {
        await VehicleService.admin.updateStatus({ id, status });
        toast.success('Vehículo actualizado con éxito');
        fetchData();

      } catch (error) {
        onError(String(error));
      }
      setCanFetch(true);
    });
  }

  const onError = (msg) => toast.error(msg);

  const reload = (inSamePage = false) => {
    setCanFetch(true);
    if (!inSamePage) setFilters(initialFilters);
    fetchData();
  }

  const goToPage = async (page) => {
    const pagination = await getUpdatedState(setPagination);
    if (page >= 1 && page <= pagination.pages && page !== pagination.page) {
      setCanFetch(true);
      setFilters({ ...filters, page });
      fetchData();
    }
  }

  const onChange = (target, value) => {
    setFilters(s => ({ ...s, page: 1, [target]: value }));
  }

  useEffect(() => {
    fetchData();
    getSelects();
  }, []);

  return {
    data,
    deleteItem,
    filters,
    goToPage,
    isLoading: !canFetch,
    onChange,
    pagination,
    reload,
    search: fetchData,
    selects,
    updateStatus,
  }
}

export default Vehicles;